export const VIDEO_LIBRARY_PATH = "/video-library";

export const videoWatchPath = (videoId: string): string => `${VIDEO_LIBRARY_PATH}/${videoId}`;

/** The catalog's filters live in its URL, so a tag on a video's page links to its catalog and Back keeps the search. */
export const SEARCH_PARAM = "q";
export const TAG_PARAM = "tag";

/** Support's switch between the library everyone watches and managing it; in the URL so a refresh or Back keeps it. */
export const MODE_PARAM = "view";
export type VideoLibraryMode = "library" | "manage";

// DEFAULT: a URL without the switch opens the library everyone watches.
export const modeOf = (params: URLSearchParams): VideoLibraryMode => (params.get(MODE_PARAM) === "manage" ? "manage" : "library");

export const VIDEO_LIBRARY_MANAGE_URL = `${VIDEO_LIBRARY_PATH}?${MODE_PARAM}=manage`;

/** Where managing the library lived before it became the page's Manage view; old links and bookmarks redirect from it. */
export const LEGACY_VIDEO_LIBRARY_MANAGE_PATH = `${VIDEO_LIBRARY_PATH}/manage`;

export const videoLibraryTagPath = (tag: string): string => `${VIDEO_LIBRARY_PATH}?${new URLSearchParams({ [TAG_PARAM]: tag })}`;

/** Two rows of cards on a wide screen; more load on request. */
export const VIDEOS_PAGE_SIZE = 24;
export const SEARCH_DEBOUNCE_MS = 300;

/** How a viewer reached a video's page, for analytics; a page opened from a shared link or a bookmark carries none. */
export type VideoOpenedFrom = "library" | "annie" | "link";
export type VideoWatchLocationState = { from: Exclude<VideoOpenedFrom, "link"> };
